import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { getFriends } from "../../../functions/user";
import { Search } from "../../../svg";
import Skeleton from "react-loading-skeleton";
import "./style.css";

export default function NewConversationModal({
  currentUser,
  onStartConversation,
  onClose,
}) {
  const [friends, setFriends] = useState([]);
  const [filteredFriends, setFilteredFriends] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const { user } = useSelector((state) => ({ ...state }));

  const loadFriends = useCallback(async () => {
    try {
      setLoading(true);
      const friendsList = await getFriends(user.token);
      
      // Check if friendsList is an array or has an error message
      if (Array.isArray(friendsList)) {
        setFriends(friendsList);
        setFilteredFriends(friendsList);
      } else {
        console.error("Error loading friends:", friendsList);
        setFriends([]);
        setFilteredFriends([]);
      }
    } catch (error) {
      console.error("Error loading friends:", error);
      setFriends([]);
      setFilteredFriends([]);
    } finally {
      setLoading(false);
    }
  }, [user.token]);

  useEffect(() => {
    loadFriends();
  }, [loadFriends]);

  useEffect(() => {
    if (searchQuery) {
      const filtered = friends.filter(friend =>
        `${friend.first_name} ${friend.last_name}`
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
      setFilteredFriends(filtered);
    } else {
      setFilteredFriends(friends);
    }
  }, [searchQuery, friends]);

  const handleStartConversation = (friendId) => {
    console.log("Starting conversation with friend ID:", friendId);
    onStartConversation(friendId);
  };

  return (
    <div className="modal_overlay" onClick={onClose}>
      <div className="new_conversation_modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal_header">
          <h3>New Conversation</h3>
          <button className="modal_close_btn" onClick={onClose}>
            <i className="exit_icon"></i>
          </button>
        </div>

        <div className="modal_search">
          <div className="search_input_wrap">
            <Search color="#65676b" />
            <input
              type="text"
              placeholder="Search friends..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search_input"
              autoFocus
            />
          </div>
        </div>

        <div className="modal_content">
          {loading ? (
            <div className="friends_skeleton">
              {Array(8).fill(0).map((_, i) => (
                <div key={i} className="friend_skeleton">
                  <Skeleton circle height={40} width={40} />
                  <div className="friend_skeleton_content">
                    <Skeleton height={14} width="60%" />
                    <Skeleton height={12} width="40%" />
                  </div>
                </div>
              ))}
            </div>
          ) : filteredFriends.length === 0 ? (
            <div className="no_friends">
              {searchQuery ? (
                <p>No friends found matching "{searchQuery}"</p>
              ) : (
                <div>
                  <p>No friends to start a conversation with</p>
                  <p style={{ fontSize: '12px', color: '#65676b', marginTop: '8px' }}>
                    Add some friends first to start chatting!
                  </p>
                </div>
              )}
            </div>
          ) : (
            <div className="friends_list">
              {filteredFriends.map((friend) => (
                <div
                  key={friend._id}
                  className="friend_item"
                  onClick={() => handleStartConversation(friend._id)}
                >
                  <img
                    src={friend.picture}
                    alt={`${friend.first_name} ${friend.last_name}`}
                    className="friend_picture"
                  />
                  <div className="friend_info">
                    <h4 className="friend_name">
                      {friend.first_name} {friend.last_name}
                    </h4>
                    <p className="friend_username">@{friend.username}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
} 